import {getProfileURI} from '../../../shared/scripts/ui_utils/TestableClientUtils'
import {UIWManagerEvents} from './UIWManagerEvents'
import {DiscordInstance} from '../discord/DiscordInstance.ts'
import {SDKRequest} from '../../../../shared/DiscordActivityTypes'
import {SocketLobbySend} from '../../../shared/scripts/socket/SocketLobbySend'
import {Scene} from './UISceneTypes'
import {navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils.ts'

export class UIDManagerEvents extends UIWManagerEvents {
    leaveRoomAndJoinRoom(roomId: string) {
        if(this.uiManager?.sceneController.scene == Scene.Room) this.uiManager?.room.resetRoom()
        void SocketLobbySend.clickedJoinRoom(roomId)
    }

    // eslint-disable-next-line class-methods-use-this
    openProfilePage(username: string, externalLink: boolean = false) {
        if(!externalLink) {
            navigateToPage(getProfileURI(username))
            return
        }
        const profileUrl = `https://colonist.io${getProfileURI(username)}`
        void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.OpenExternalLink, profileUrl)
    }
}
